import React, { useState } from 'react';
import { convertLocalToExternal } from '../services/imageService';

interface Moment {
    name: string;
    date: string;
    theme: string;
    photos: string[];
}

interface TimelineProps {
    moments: Moment[];
}

const Timeline: React.FC<TimelineProps> = ({ moments }) => {
    const [selectedPhoto, setSelectedPhoto] = useState<string | null>(null);

    const openModal = (photo: string) => {
        setSelectedPhoto(photo);
    };

    const closeModal = () => {
        setSelectedPhoto(null);
    };

    // Função para obter URL da imagem (converte path local para Cloudinary)
    const getPhotoUrl = (photo: string): string => {
        return convertLocalToExternal(photo);
    };

    return (
        <div className="timeline space-y-8">
            {moments.map((moment, index) => (
                <div key={index} className="photos grid grid-cols-1 sm:grid-cols-2 gap-y-8 gap-x-4">
                    {moment.photos.map((photo, idx) => (
                        <div
                            key={idx}
                            className="photo-frame bg-white p-4 shadow-lg cursor-pointer flex flex-col items-center border border-gray-300"
                            onClick={() => openModal(photo)}
                            style={{ borderRadius: 0 }}
                        >
                            <div
                                className="bg-white border border-gray-300 w-48 h-48 overflow-hidden flex items-center justify-center"
                            >
                                <img
                                    src={getPhotoUrl(photo)}
                                    alt={`${moment.name} ${idx + 1}`}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <p className="text-center text-sm text-gray-700 mt-2 font-semibold">{moment.name}</p>
                        </div>
                    ))}
                </div>
            ))}

            {/* Modal */}
            {selectedPhoto && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
                    onClick={closeModal}
                >
                    <div className="relative">
                        <img
                            src={getPhotoUrl(selectedPhoto)}
                            alt="Foto ampliada"
                            className="max-w-full max-h-screen rounded-lg"
                        />
                        <button
                            className="absolute top-4 right-4 text-white text-2xl bg-black bg-opacity-50 rounded-full p-2"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Timeline;